import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { getSidebarStatus, setSidebarStatus } from '@/utils/cookies'
import store from '@/store'

export enum DeviceType {
  Mobile,
  Desktop
}

export interface IAppState {
  device: DeviceType
  sidebar: {
    opened: boolean
    withoutAnimation: boolean
    
  }
  statusNumber:Number
}

@Module({ 'dynamic': true, store, 'name': 'app' })
class App extends VuexModule implements IAppState {
  public sidebar = {
    'opened': true, //getSidebarStatus() !== 'closed',
    'withoutAnimation': false
  }
  public device = DeviceType.Desktop
  public statusNumber = 0
  @Mutation
  private TOGGLE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = !this.sidebar.opened
    this.sidebar.withoutAnimation = withoutAnimation
    setSidebarStatus(this.sidebar.opened ? 'opened' : 'closed')
  }

  @Mutation
  private CLOSE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = false
    this.sidebar.withoutAnimation = withoutAnimation
    setSidebarStatus('closed')
  }

  @Mutation
  private STATUS_NUMBER(device: DeviceType) {
    this.statusNumber = device
  }

  @Mutation
  private TOGGLE_DEVICE(device: DeviceType) {
    this.device = device
  }

  @Action
  public ToggleSideBar(withoutAnimation: boolean) {
    this.TOGGLE_SIDEBAR(withoutAnimation)
  }

  @Action
  public CloseSideBar(withoutAnimation: boolean) {
    this.CLOSE_SIDEBAR(withoutAnimation)
  }

  @Action
  public ToggleDevice(device: DeviceType) {
    this.TOGGLE_DEVICE(device)
  }

  @Action
  public StatusNumber(device: any) {
    this.STATUS_NUMBER(device)
  }
}

export const AppModule = getModule(App)
